import type { ScriptTokenContextType } from '@/context/escript/ScriptTokenContext';
import { ScriptTokenContext } from '@/context/escript/ScriptTokenContext';
import { useContext } from 'react';

export const useScriptTokenContext = (): ScriptTokenContextType => {
  const context = useContext(ScriptTokenContext);
  if (!context) {
    throw new Error('useScriptTokenContext must be used within the ScriptTokenContext provider');
  }
  return context;
};
